export default {
  STATUS: {
    canceled_0: 0, // 已取消
    waittingToVerify_1: 1, // 待预审
    verifyNotPassed_2: 2, // 预审未通过
    waittingToDeliver_3: 3, // 待送签
    embassyVerifing_4: 4, // 使馆审核中
    handleVisaSuccess_5: 5, // 出签成功
    refusedVisa_6: 6, // 拒签
    refunding_7: 7, // 退款中
    refundSuccess_8: 8, // 退款成功
    waittingToAppointment_9: 9, // 等待预约
    waittingToEnsure_10: 10, // 待确认
    waittingToReceiveMateril_11: 11, // 等待接受资料
    waittingToTraining_12: 12, // 等待培训
    waittingToGoToEmbassy_13: 13, // 待前往使馆
    refuse_waittingToUploadProve_14: 14, // 拒签(待提交证明)
    refuse_waittingToVerify_15: 15, // 拒签(等待审核)
    refuse_VerifyNotPass_16: 16, // 拒签(审核不通过)
    verifyNotPass_waittingToRefund_17: 17, // 预审未通过(待退款)
    appointGoToEmbassyTimeSuccess_18: 18, // 预约(赴馆日期)成功
  },

  APPLICATION_GROUP_STATUS: {
    valid: 1,
    unknown: 0,
    invalid: -1,
  },
};



// WEBPACK FOOTER //
// ./src/constants/applicant-constants.js